import $ from 'jquery';
import { onErrorShowMessage } from '~src/errors';
import { getAxiosClient } from '~src/api';
import { addImageTagToCache } from './addImageTagToCache';
import { isLoggedUserGlobalEditor } from '~src/user';

export const saveNewTags = async (imageId, tags) => {
  $('#saveNewTags #editor-btn-spinner').show();
  const httpClient = await getAxiosClient();
  const isGlobalEditor = await isLoggedUserGlobalEditor();

  let tableName;
  if (!isGlobalEditor) {
    tableName = 'editor_images';
  } else {
    tableName = 'editor_images_default';
  }
  const url = `${process.env.PARSE_API_URL}/${tableName}/${imageId}`;
  const method = 'PUT';
  const data = {
    relations: [
      {
        column: 'tags',
        class: 'editor_images_tags',
        toIds: tags,
      },
    ],
  };
  try {
    await httpClient({ url, method, data: { data }, responseType: 'json' });
    addImageTagToCache(imageId, tags);
  } catch (error) {
    console.error(error);
    onErrorShowMessage();
  }
};
